<!--
  @修改人：黎柏祺
  @修改时间：2018-10-28
  @修改描述：框架升级
  @版本:v1.0.26
  ------------
  @负责人：libaiqi
  @创建日期：2018-9-18
  @版本号：V1.0.21
  @描述： 程序包管理
-->
<template>
  <div class="packageManage__content">
    <div class="packageManage__operation">
      <el-button type="primary" @click="e_createPackage" v-g-rac="gRac('programPackage@createPackage')">{{ $t('packageManage.createPackage') }}</el-button>
      <el-button type="primary" @click="e_edit" v-g-rac="gRac('programPackage@createPackage')">{{ $t('packageManage.edit') }}</el-button>
      <el-button type="danger"  @click="e_delete" v-g-rac="gRac('programPackage@deletePackage')">{{ $t('packageManage.delete') }}</el-button>
    </div>
    <div class="packageManage__form">
      <el-form ref="form" :model="form" :inline="true" label-width="0" >
        <el-form-item>
          <el-input v-model="form.packageName" prefix-icon="uk-icon-search" :placeholder="$t('packageManage.searchPackage')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="login-btn" @click="e_search" v-g-rac="gRac('programPackage@searchPackage')">{{ $t('packageManage.search') }}</el-button>
        </el-form-item>
      </el-form>      
    </div>
    <div class="packageManage__table">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="storeSelection">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="group"
          :label="$t('packageManage.table.group')">
        </el-table-column>
        <el-table-column
          prop="packageName"
          :label="$t('packageManage.table.packageName')">
          <template slot-scope="scope">
            <div class="packageManage__tag" @click="skipToConfigPage(scope.row)">
              <el-button type="text" size="small">{{ scope.row.packageName}}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="version"
          :label="$t('packageManage.table.newVersion')">
          <template slot-scope="scope">
            <div class="packageManage__tag" @click="skipToVersionPage(scope.row)">
               <el-button type="text" size="small">{{ scope.row.version | formatVersion}}</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="instanceName"
          :show-overflow-tooltip="showOverflow"
          :label="$t('packageManage.table.instanceName')">
        </el-table-column>
        <el-table-column
          prop="creator"
          :label="$t('packageManage.table.creator')">
        </el-table-column>
        <el-table-column
          prop="createTime"
          :formatter="formatTime"
          :label="$t('packageManage.table.createTime')">
        </el-table-column>
      </el-table>
      <div class="el-table-extend__pager">
        <el-pagination
          background
          @size-change="sizeChange"
          @current-change="currentChange"
          layout="total, sizes, prev, pager, next, jumper"        
          :current-page="currentPage"
          :page-size="pageSize"
          :page-count="pageCount"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :closeOnClickModal="false" :title="dialogTitle" :visible.sync="dialogFormVisible" >
      <el-form :model="packageForm" label-position="left" label-width="120px" ref="packageForm" :rules="rules" >
        <el-form-item :label="$t('packageManage.group')" prop="group">
          <el-select v-model="packageForm.group">
            <el-option :label="item" :value="index" v-for="(item,index) in groupList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('packageManage.appName')" prop="appName">
          <el-select v-model="packageForm.appName">
            <el-option :label="item" :value="item" v-for="(item,index) in appList" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('packageManage.packageName')" prop="packageName">
          <el-input v-model="packageForm.packageName" ></el-input>
        </el-form-item>
        <el-form-item :label="$t('packageManage.deployPath')" prop="deployPath">
          <el-input v-model="packageForm.deployPath" ></el-input>
        </el-form-item>
        <el-form-item :label="$t('packageManage.os')" prop="os">
          <el-radio-group v-model="packageForm.os">
            <el-radio :label="index" v-for="(item,index) in osList" :key="index"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item :label="$t('packageManage.desc')">
          <el-input v-model="packageForm.desc" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">{{$t('packageManage.cancle')}}</el-button>
        <el-button type="primary" @click="submitForm" v-g-rac="gRac('programPackage@createPackage')" >{{$t('packageManage.confirm')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import dic from '@/components/mixins/dic'
  import packageManageBiz from '@/logic/continuousDelivery/programPackageManageBiz.js'
  import rac from '@/plugins/rac-mixin.js'
  export default {
    mixins: [dic, rac],
    data () {
      const that = this
      return {
        form: {
          packageName: ''
        },
        packageForm: {
          group: '',
          appName: '',
          packageName: '',
          os: '',
          desc: '',
          deployPath: ''
        },
        rules: {
          packageName: [
            { required: true, message: that.$t('packageManage.rules.packageName'), trigger: 'blur' }
          ],
          os: [
            { required: true, message: that.$t('packageManage.rules.os'), trigger: 'change' }
          ],
          appName: [
            { required: true, message: that.$t('packageManage.rules.appName'), trigger: 'change' }
          ],
          group: [
            { required: true, message: that.$t('packageManage.rules.group'), trigger: 'change' }
          ],
          deployPath: [
            { required: true, message: that.$t('packageManage.rules.deployPath'), trigger: 'blur' }
          ],
          desc: [
            { required: false, trigger: 'blur' }
          ]
        },
        tableData: [],
        multipleSelection: [],
        currentPage: 1,
        pageSize: 10,
        pageCount: 0,
        total: 0,
        dialogFormVisible: false,
        isAmend: false,
        dialogTitle: '',
        appList: [],
        osList: {},
        editFlag: false,
        showOverflow: true,
        groupList: {}
      }
    },
    components: {
    },
    computed: {
    },
    filters: {
      formatVersion (version) {
        if (version === null) {
          return '新建版本'
        } else {
          return version
        }
      }
    },
    methods: {
      e_init () {
        this.dialogTitle = this.$t('packageManage.createPackage')
        this.waitGroupList()
        this.waitOsType()
      },
      async waitGroupList () {
        await this.dGetGroup()
        this.groupList = this.$store.state.dicModule.group
      },
      async waitAppList (group) {
        await this.dGetAppByGroup('', group)
        this.appList = { ...this.dDictionaryApp[group] }
        this.packageForm.appName = Object.keys(this.appList)[0]
      },
      async waitOsType () {
        await this.dGetDictionaryByCode('osType')
        this.osList = { ...this.dDictionary.osType }
      },
      search (data) {
        let d = {
          currentPage: 1,
          perPageCount: 10,
          ...data
        }
        packageManageBiz.findAllPackage(d).then((data) => {
          // console.info('view getList', data);
          this.tableData = data.dataList
          this.total = data.totalCount
          this.pageCount = data.totalPageCount
        }).catch((err) => {
          console.error(err)
        })
      },
      currentChange (data) {
        this.search({
          currentPage: data
        })
      },
      sizeChange (data) {
        this.search({
          perPageCount: data
        })
      },
      storeSelection (data) {
        this.multipleSelection = data
      },
      e_search () {
        let d = {
          packageName: this.form.packageName
        }
        this.search(d)
      },
      e_createPackage () {
        this.isAmend = false
        this.dialogFormVisible = true
        this.packageForm = {
          group: Object.keys(this.groupList)[0],
          appName: Object.keys(this.appList)[0],
          packageName: '',
          os: Object.keys(this.osList)[0],
          desc: '',
          deployPath: ''
        }
      },
      e_edit () {
        const that = this
        if (that.multipleSelection.length !== 1) {
          that.$message({
            message: that.$t('packageManage.rules.edit'),
            type: 'warning'
          })
          return
        }
        that.isAmend = true
        that.dialogFormVisible = true
        that.editFlag = true
        Object.keys(that.packageForm).forEach((item) => {
          that.packageForm[item] = that.multipleSelection[0][item]
        })
        setTimeout(() => {
          that.editFlag = false
        }, 0)
      },
      e_delete () {
        const that = this
        if (that.multipleSelection.length === 0) {
          that.$message({
            message: that.$t('packageManage.rules.delete'),
            type: 'warning'
          })
          return
        }
        that.$confirm(that.$t('common.deleteTips'), that.$t('common.delete'), {
          confirmButtonText: that.$t('common.confirm'),
          cancelButtonText: that.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          let ids = []
          that.multipleSelection.forEach((item) => {
            ids.push(item.id)
          })
          packageManageBiz.deleteAppPackage({ ids: ids }).then(() => {
            that.$message({
              message: that.$t('common.success'),
              type: 'success'
            })
            setTimeout(() => {
              that.search()
            }, 500)
          })
        }).catch(() => {})
      },
      submitForm () {
        this.$refs.packageForm.validate((valid) => {
          if (valid) {
            if (this.isAmend) {
              this.packageForm.id = this.multipleSelection[0].id
              packageManageBiz.updatePackage(this.packageForm).then(() => {
                this.$message({
                  message: this.$t('packageManage.success'),
                  type: 'success'
                })
                setTimeout(() => {
                  delete this.packageForm.id
                  this.search()
                  this.resetForm()
                }, 500)
              })
            } else {
              packageManageBiz.saveAppPackage(this.packageForm).then(() => {
                this.$message({
                  message: this.$t('packageManage.success'),
                  type: 'success'
                })
                setTimeout(() => {
                  this.search()
                  this.resetForm()
                }, 500)
              })
            }
          } else {
            return false
          }
        })
      },
      resetForm () {
        this.dialogFormVisible = false
        this.$refs.packageForm.resetFields()
      },
      formatTime (row, column) {
        let date = new Date(row.createTime)
        let Y = date.getFullYear() + '-'
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
        let D = date.getDate() + ' '
        let h = date.getHours() + ':'
        let m = date.getMinutes() + ':'
        let s = date.getSeconds()
        return Y + M + D + h + m + s
      },
      skipToVersionPage (row) {
        let query = {}
        query.pkId = row.id
        query.packageName = row.packageName
        if (row.version !== null) {
          query.from = 'packageManage'
          query.version = row.version
        }
        this.$router.push({ path: '/home/programPackageManage/createVersion', query: query })
      },
      skipToConfigPage (row) {
        let query = {}
        query.pkId = row.id
        query.packageName = row.packageName
        this.$router.push({ path: '/home/programPackageManage/packageConfig', query: query })
      }
    },
    mounted () {
      this.$nextTick(() => {
        // this.initTable();
        this.e_init()
        this.search()
      })
    },
    watch: {
      'isAmend' () {
        this.dialog = this.isAmend === false ? this.$t('packageManage.createPackage') : this.$t('packageManage.editPackage')
      },
      'packageForm.group' () {
        this.waitAppList(this.packageForm.group)
      },
      '$route' (to, from) {
        if (to.name === 'programPackageManage' && (from.name === 'createVersion' || from.name === 'packageConfig')) {
          this.search()
        }
      }
    }

  }
</script>
<style scoped>
  .packageManage__content .packageManage__tag{
    cursor:pointer;
  }
  .packageManage__operation{
    margin:15px 0;
  }
  .packageManage__content .el-radio + .el-radio{
    margin-left:20px;
  }
</style>
    
